import * as React from 'react'

const SvgZoomOutIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.625 8.125h6.25v1.25h-6.25v-1.25zm8.406 5a6.793 6.793 0 001.594-4.375 6.875 6.875 0 10-6.875 6.875c1.6 0 3.15-.564 4.375-1.594l4.744 4.719.881-.881-4.719-4.744zm-5.281 1.25a5.625 5.625 0 110-11.25 5.625 5.625 0 010 11.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgZoomOutIcon
